
export const UNIT_GROUP_DEFAULT_FILTER = {
    id: undefined,
    name: undefined,
  };